/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Title_1Inputs */

const en_projects_title_1 = /** @type {(inputs: Projects_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas put`)
};

const lv_projects_title_1 = /** @type {(inputs: Projects_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idejas,`)
};

/**
* | output |
* | --- |
* | "Ideas put" |
*
* @param {Projects_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_title_1 = /** @type {((inputs?: Projects_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_title_1(inputs)
	return en_projects_title_1(inputs)
});